export const WhitelistDomains = [
  'nypl.org'
];
